import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DicionarioService {

  constructor(
    private http: HttpClient
  ) { }

  fsbDicionario(parameters?: any) {
    let link = `${environment.protheus}/dicionario?${parameters}`;
    return this.http.get(link);
  }
}
